import CMX from "../../../api";
import * as actions from "../../types";
import { GiftCard } from "../../../types/gift-card";
import { dialogClose, dialogOpen } from "../dialogs";

export const fetchUserWalletCards = () => (dispatch: any, getState: any) => {
    dispatch({
        type: actions.USER_WALLET_CARDS_FETCH,
    });

    return CMX.get('/me/wallet/cards', {}) // @todo Move to middleware
        .then((response: any) => {
            dispatch({
                type: actions.USER_WALLET_CARDS_FETCH_SUCCESS,
                payload: response,
            });
        }).catch((error: any) => {
            dispatch({
                type: actions.USER_WALLET_CARDS_FETCH_ERROR,
                error,
            });
        });
};

export const userWalletCardDetailOpen = (giftCard: GiftCard) => ({
    type: actions.USER_WALLET_CARD_DETAIL_OPEN,
    payload: giftCard,
});

export const userWalletCardDetailClose = () => ({
    type: actions.USER_WALLET_CARD_DETAIL_CLOSE,
});

export const userWalletCardRemove = (id: number) => (dispatch: any, getState: any) => {
    function removeCard(id: number) {
        dispatch({
            type: actions.USER_WALLET_CARD_REMOVE,
            id,
        });

        return CMX.delete(`/me/wallet/cards/${id}`, {}) // @todo Move to middleware
            .then((response: any) => {
                dispatch({
                    type: actions.USER_WALLET_CARD_REMOVE_SUCCESS,
                    payload: response,
                    id,
                });
            }).catch((error: any) => {
                dispatch({
                    type: actions.USER_WALLET_CARD_REMOVE_ERROR,
                    error,
                    id,
                });
            });
    }

    dispatch(dialogOpen({
        message: '¿Estás seguro que deseas eliminar esta tarjeta de tu wallet?',
        buttons: [
            {
                label: 'Cancelar',
                onClick: (dialog) => {
                    dialog.id && dispatch(dialogClose(dialog.id));
                }
            },
            {
                label: 'Continuar',
                primary: true,
                onClick: (dialog) => {
                    dialog.id && dispatch(dialogClose(dialog.id));
                    setTimeout(function () { // For some reason at some version of Chrome it started crashing here, so this is a workaround.
                        removeCard(id);
                    }, 10);
                }
            }
        ]
    }));
};


export const userWalletCardBalanceFetch = (id: number) => (dispatch: any, getState: any) => {
    dispatch({
        type: actions.USER_WALLET_CARD_BALANCE_FETCH,
        id,
    });

    return CMX.get(`/me/wallet/cards/${id}/balance`, {}) // @todo Move to middleware
        .then((response: any) => {
            dispatch({
                type: actions.USER_WALLET_CARD_BALANCE_FETCH_SUCCESS,
                payload: response,
                id,
            });
        }).catch((error: any) => {
            dispatch({
                type: actions.USER_WALLET_CARD_BALANCE_FETCH_ERROR,
                error,
                id,
            });
        });
}

export const userWalletCardPinRequest = (id: number) => ({
    type: actions.USER_WALLET_CARD_PIN_REQUEST,
    id,
});